import { FilterAltOff } from '@mui/icons-material'
import { Stack, Button, Tooltip, IconButton } from '@mui/material'
import React from 'react'
import { Control } from 'react-hook-form'
import { ControlledAutocomplete } from 'src/components/forms/ControlledAutocomplete'
import { HttpCacheWorkflow } from 'src/http/workflow/httpCacheWorkflow'
import { UserGroupFilterDTOFields } from 'src/types/user/userData'

interface WorkflowFilterProps {
    control: Control<any>,
    name: string,
    onReset: () => void,
    onSearch: () => void,
}

const WorkflowFilter = ({control, name, onReset, onSearch}:WorkflowFilterProps) => {
    return (
        <Stack
            direction='row'
            spacing={2}
            sx={{
                display: 'flex',
                justifyContent: 'space-between',
                p: 2
            }}
        >
            <ControlledAutocomplete
                control={control}
                name={name}
                valueField='id'
                loadOptions={HttpCacheWorkflow.getSistemasTipos}
                multiple
            />
            <Button type='submit' onClick={onSearch}>
                Buscar
            </Button>
            <Tooltip title='Limpiar filtro'>
                <IconButton
                    onClick={onReset}
                >
                    <FilterAltOff />
                </IconButton>
            </Tooltip>
        </Stack>
    )
}

export default WorkflowFilter
